import { types } from 'mobx-state-tree';
import * as views from './supportMessagesStoreViews';
import * as actions from './supportMessagesStoreActions';

const SupportMessagesStore = types
  .model('SupportMessagesStore', {
    messages: types.optional(types.array(types.frozen()), []),
    myMessages: types.optional(types.array(types.frozen()), []),
    count: types.optional(types.number, 0),
    loading: types.optional(types.boolean, false),
    sending: types.optional(types.boolean, false)
  })
  .views(views.supportMessagesStoreViews)
  .actions(actions.supportMessagesStoreActions);

export default SupportMessagesStore;
